import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import styles from "./ListViewFaculty.module.css";
import FaclityDetailProfile from "./FaclityDetailProfile";
import Faculityschedule from "./Faculityschedule";
import SalaryListView from "./SalaryListView";
import TeachingProgress from "./normalFaculity/TeachingProgress";

function FacultyDetailview() {
  const { userId, staff_id, active_tab } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { STAFFTYPE, CATEGORY, SUBJECT, STATUS, SEARCHTERM, LOCATION, DESIGNATION, FAPON, FROM } =
    location.state || {};
    
  const [activeTab, setActiveTab] = useState(1);

  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;
  let staff_type = null;
  if (userJSON) {
    const user = JSON.parse(userJSON);

    if (user && user.user_id) {
      userid = user.user_id;
      staff_type = user.staff_type ? user.staff_type : STAFFTYPE;
    }
  } else {
    console.log("User Id cannot avaliable in session storage");
  }

  useEffect(() => {
    setActiveTab(Number(active_tab) || 1);
  }, [active_tab]);

  const handleTabClick = (index) => {
    setActiveTab(index);
    navigate(`/Faculties/FacultyDetailView/${userId}/${staff_id}/${index}/${FROM}`);
  };

  const navigateToPreviousScreen = () => {
    navigate(`/Faculties/1`, {
      state: {
        filCate: CATEGORY,
        filSubject: SUBJECT,
        filStatus: STATUS,
        filSearch: SEARCHTERM,
        filDesign: DESIGNATION,
        filLocation: LOCATION,
        fillAon: FAPON,
        filFrom: FROM
      },
    }); // Navigate back by one step in the history
  };

  return (
    <div className={`${styles.cm_container} BathHeader`}>
      <div className="row align-items-center mb-3">
        <div className="col-md-12 d-flex justify-content-between flex-wrap">
          <h2 className="TitleHeader mb-0">View Faculty Profile</h2>
          <Link
            to="javascript:void(0)"
            onClick={navigateToPreviousScreen}
            className="secondaryButton "
            variant="secondary"
          >
            Back to Faculties
          </Link>
        </div>
      </div>

      <div className="row">
        <div className="col-md-12">
          {/* nav-tabs */}
          <ul
            className="nav cm_nav-fill mb-3"
            id="cm_listViewTabs"
            role="tablist"
          >
            <li className="nav-item" role="presentation">
              <a
                className={activeTab === 1 ? "nav-link active" : "nav-link"}
                // id="ex2-tab-1"
                data-mdb-toggle="tab"
                href="javascript:void(0)"
                role="tab"
                aria-controls="ex2-tabs-1"
                aria-selected={activeTab === 1}
                onClick={() => handleTabClick(1)}
              >
                Schedule
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className={activeTab === 2 ? "nav-link active" : "nav-link"}
                // id="ex2-tab-2"
                data-mdb-toggle="tab"
                href="javascript:void(0)"
                role="tab"
                aria-controls="ex2-tabs-2"
                aria-selected={activeTab === 2}
                onClick={() => handleTabClick(2)}
              >
                Teaching Progress
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className={activeTab === 3 ? "nav-link active" : "nav-link"}
                // id="ex2-tab-3"
                data-mdb-toggle="tab"
                href="javascript:void(0)"
                role="tab"
                aria-controls="ex2-tabs-3"
                aria-selected={activeTab === 3}
                onClick={() => handleTabClick(3)}
              >
                Salary
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className={activeTab === 4 ? "nav-link active" : "nav-link"}
                // id="ex2-tab-4"
                data-mdb-toggle="tab"
                href="javascript:void(0)"
                role="tab"
                aria-controls="ex2-tabs-4"
                aria-selected={activeTab === 4}
                onClick={() => handleTabClick(4)}
              >
                Profile
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Tab content */}
      {activeTab === 1 && (
        <Faculityschedule
          staff_type={staff_type}
          staff_id={staff_id}
          activeTab={activeTab}
          FROM={FROM}
        />
      )}
      {activeTab === 2 && (
        <TeachingProgress
          staff_type={staff_type}
          staff_id={staff_id}
          userId={userId}
          activeTab={activeTab}
          FROM={FROM}

        />
      )}
      {activeTab === 3 && (
        <SalaryListView
          staff_type={staff_type}
          staff_id={staff_id}
          userId={userId}
          activeTab={activeTab}
          from="ADMIN"
          FROM={FROM}

        />
      )}

      {activeTab === 4 && (
        <FaclityDetailProfile
          staff_type={staff_type}
          staff_id={staff_id}
          userId={userId}
          activeTab={activeTab}
          from="ADMIN"
        />
      )}
    </div>
  );
}

export default FacultyDetailview;
